import { render } from "./tripAdditionalInfoCheckboxModalComponent.vue?vue&type=template&id=612ba6a9&scoped=true&ts=true"
import script from "./tripAdditionalInfoCheckboxModalComponent.vue?vue&type=script&lang=ts"
export * from "./tripAdditionalInfoCheckboxModalComponent.vue?vue&type=script&lang=ts"

import "./tripAdditionalInfoCheckboxModalComponent.vue?vue&type=style&index=0&id=612ba6a9&scoped=true&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612ba6a9"]])

export default __exports__